import * as _actions from './actions';
import _reducer from './reducer';
import _HomeworkContent from './model';

export const actions = _actions;
export const reducer = _reducer;
export const HomeworkContent = _HomeworkContent;



// WEBPACK FOOTER //
// ./data/Homework/Content/index.js